export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_accounts(state, {accounts}) {
    state.accounts = accounts;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  },
  set_account(state, {account}) {
    state.account = account
    state.loaded = true;
  }
};
